import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import en from "./locales/en/global.json";
import pl from "./locales/pl/global.json";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";

i18next.init({
  interpolation: { escapeValue: false },
  lng: "en", 
  resources: {
    en: {
      global: en,
    },
    pl: {
      global: pl,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);
